export default "__VITE_ASSET__b8c1a06b__"